"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React, { useState } from "react";
import { Calendar, ArrowRight } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Calendar as CalendarComponent } from "@/components/ui/calendar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function ReadyToScale() {
  const [date, setDate] = useState<Date | undefined>(new Date());
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="241292" id="complete-exterior-solutions" className="dark bg-black text-white relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/siding_installation_parallax.png" alt="Siding Installation" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-black/70" />
      </div>

      <div ref={ref} className={`container relative z-10 mx-auto px-4 md:px-6 max-w-3xl text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="inline-flex items-center rounded-none border border-primary/30 bg-primary/10 px-3 py-1 text-sm font-semibold tracking-widest uppercase mb-8 text-secondary">
          <span className="flex h-2 w-2 rounded-none bg-primary mr-2 animate-pulse"></span>
          Eagle Exteriors
        </div>

        <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter mb-6 text-balance">
          Complete Protection for Your Home
        </h2>
        
        <p className="font-default text-lg md:text-xl text-white/80 mb-10 max-w-2xl mx-auto text-balance">
          From premium siding to storm-proof roofing, we provide the durable exterior solutions your property deserves. Trust the local experts for your next renovation.
        </p>

        <Dialog>
          <DialogTrigger asChild className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive has-[>svg]:px-4 group group group h-14 px-8 text-lg rounded-none shadow-none text-black hover:bg-primary/90 transition-transform hover:scale-[1.02] group bg-secondary">
            <Link className="h-14 px-8 text-lg rounded-none shadow-none bg-primary text-black hover:bg-primary/90 transition-transform hover:scale-[1.02] group underline cursor-pointer" to="/ServiceAreasPage"><Button size="lg">
              <SafeHydrate><Calendar className="mr-2 size-5 transition-transform group-hover:scale-110" /></SafeHydrate>
              VIEW ALL SERVICES
              <ArrowRight className="ml-2 size-5 opacity-70 transition-transform group-hover:translate-x-1" />
            </Button></Link>
          </DialogTrigger>
          <DialogContent className="sm:max-w-[425px] p-0 overflow-hidden border-primary/20 shadow-4xl rounded-none">
            <div className="p-6 bg-black border-b border-primary/20">
              <DialogHeader>
                <DialogTitle className="font-default text-2xl text-white">Schedule Your Estimate</DialogTitle>
                <DialogDescription className="font-default text-base text-white/70">
                  Select a time for our specialists to visit your property and provide a comprehensive exterior assessment.
                </DialogDescription>
              </DialogHeader>
            </div>
            <div className="p-6 flex flex-col items-center justify-center bg-black">
              <SafeHydrate><CalendarComponent mode="single" selected={date} onSelect={setDate} className="rounded-none border border-primary/20 shadow-sm bg-black text-white" disabled={date => date < new Date(new Date().setHours(0, 0, 0, 0))} /></SafeHydrate>
              
              <div className="mt-6 w-full flex justify-end gap-3">
                <Button variant="outline" className="w-full sm:w-auto rounded-none border-primary/50 text-white hover:bg-primary/10">
                  Cancel
                </Button>
                <Button className="w-full sm:w-auto rounded-none bg-primary text-black hover:bg-primary/90">
                  Confirm Time
                </Button>
              </div>
            </div>
          </DialogContent>
        </Dialog>

        <p className="font-default text-sm text-white/50 mt-8 uppercase tracking-widest">
          Licensed • Insured • Local Craftsmanship
        </p>
      </div>
    </section>;
}